import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DateField from "../../../../common/components/functional/dateField/DateField";
import { BULK_SALARY_INCREASE_FILTER_NAMES, LABEL_WIDTH } from "../constants";

type Props = {
  ktaMode?: boolean;
  /** Earliest selectable day for the salary row date (e.g. TES_TABLES target table effective date). */
  minDate?: Date;
};

const SalaryIncreaseConfigBasic = ({ ktaMode = false, minDate }: Props) => {
  const { t } = useTranslation();
  
  return (
  <>
    <Grid id="bulk-salary-increase-filters-config" item xs={12}>
      <Typography variant="header" fontSize="20px" fontWeight={500}>
        {t("settings:bulkSalaryIncrease.correctionSelectionsTitle")}
      </Typography>
    </Grid>

    <Grid container item xs={12} alignItems="center" columnSpacing={2}>
      <Grid
        item
        style={{
          width: LABEL_WIDTH,
          textAlign: "end",
          wordBreak: "break-all",
        }}
      >
          <Typography variant="secondary">
              {ktaMode && "Kta päivämäärä"}
              {!ktaMode && "Uusi palkkarivin pvm"}
          </Typography>
      </Grid>
      <Grid item xs>
        <DateField
          name={BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_INCREASE_START_DATE}
          required={{ value: true, message: "" }}
          sx={{ maxWidth: "230px" }}
          minDate={minDate}
        />
      </Grid>
    </Grid>
  </>
  );
};

export default SalaryIncreaseConfigBasic;
